"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDSValueToUI = exports.mapParticipantResponseToState = void 0;
var types_1 = require("../../types");
function mapParticipantResponseToState(res) {
    return res.map(function (r) {
        var _a;
        return ({
            id: r.id,
            title: r.content.name,
            value: r.content.primaryGroupId
                ? (_a = r.content.clientGroups.find(function (g) { return g.id === r.content.primaryGroupId; })) === null || _a === void 0 ? void 0 : _a.name : undefined,
            content: r.content,
        });
    });
}
exports.mapParticipantResponseToState = mapParticipantResponseToState;
function mapWorkLocationResponseToState(res) {
    return res.map(function (r) { return ({
        id: r.id,
        title: r.content.name,
        content: r.content,
    }); });
}
function mapBasicResponseToState(res) {
    return res.map(function (r) { return ({
        id: r.id,
        title: r.content.value,
        content: r.content,
    }); });
}
function mapDSValueToUI(res, dataSourceKey) {
    switch (dataSourceKey) {
        case types_1.DataSourceType.PARTICIPANT:
            return mapParticipantResponseToState(res);
        case types_1.DataSourceType.WORK_LOCATION:
            return mapWorkLocationResponseToState(res);
        default:
            return mapBasicResponseToState(res);
    }
}
exports.mapDSValueToUI = mapDSValueToUI;
//# sourceMappingURL=dataSource.js.map